module.exports = __webpack_public_path__ + "static/img/icon-hives.027de9cd.svg";